<script setup>
import { storeToRefs } from 'pinia';
import { useStandingStore } from '../stores/standing-store';
import StandingNavComponent from '../components/StandingNavComponent.vue';
import { usePermissions } from '../../../auth/composables/permissions';
import defaultLogo from '../../../app/assets/event_logo.png';

/**
 * Permissions
 */
const { isAllowed } = usePermissions();

/**
 * Standings
 */
const { standing, loading } = storeToRefs(useStandingStore());
</script>

<template>
  <div class="container">
    <div class="row my-3 align-items-center" v-if="!loading && standing">
      <div class="col-12 col-md-auto">
        <div class="standing-logo d-flex justify-content-center align-items-center overflow-hidden rounded-3">
          <img :src="standing.logo ?? defaultLogo" class="img-fluid w-100 h-100 object-fit-cover" alt="Standing Logo">
        </div>
      </div>
      <div class="col align-self-end mt-3">
        <h2 class="m-0">{{ standing.name }}</h2>
      </div>
      <div class="col-12 col-md-auto align-self-end">
        <RouterLink
          :to="{
            name: 'standing.manage.detail',
          }"
          class="btn btn-primary mt-3 ms-md-1 w-100"
          v-if="standing && isAllowed('standing.manage.detail', standing.security)"
        >
          Manage Standing
        </RouterLink>
      </div>
    </div>

    <StandingNavComponent />

    <RouterView />
  </div>
</template>

<style scoped>
.standing-logo {
  max-width: 100px;
}
@media (min-width: 576px) {
  .standing-logo {
    max-width: 100px;
  }
}
@media (min-width: 768px) {
  .standing-logo {
    max-width: 150px;
  }
}
@media (min-width: 992px) {
  .standing-logo {
    max-width: 200px;
    max-height: 200px;
  }
}
</style>
